const ProfileData = {
  img: require("../assets/Images/hero.png"),
  logo: require("../assets/Images/Name.png"),

  name: "Yogesh Verma",

  professions: [
    "DevOps Engineer",
    "DevSecOps Practitioner",
    "Cloud & Kubernetes Engineer",
    "CI/CD | GitOps | Automation"
  ],

  info: [
    "I design and operate secure, scalable, and automated cloud-native delivery pipelines.",
    "Focused on CI/CD, GitOps, Kubernetes, cloud security, and reliability engineering."
  ],

  resume: "/Yogesh_Verma_DevOps_Engineer.pdf"
};

export default ProfileData;
